export const gradeOptions = ['A+', 'A', 'B+', 'B', 'C+', 'C', 'D', 'E', 'F'];
